import { FieldDefinition } from '../../models/field-definition.class';
import { Organization } from '../../models/organization.class';

export const locationsInitialState: LocationInitialState = {
    associatedOrganizations: [],
    associatedOrgIdVsNameMap: {},
    flexfields: [],
    organizationLocations: {},
    locationCodes: {},
    logoMapWithHierarchy: {},
    logoMap: {},
    orgChildHierarchy: {},
    orgIdsVsOrgNames: {},
    relatedTenants: {},
};

export interface LocationInitialState {
    associatedOrganizations: Organization[];
    associatedOrgIdVsNameMap: { [property: string]: string };
    flexfields: FieldDefinition[];
    organizationLocations: {
        [organizationId: string]: Organization[];
    };
    locationCodes: {};
    logoMapWithHierarchy: {
        [property: string]: string;
    };
    logoMap: {
        [property: string]: string;
    };
    orgChildHierarchy: {
        // orgId vs orgChildHierarchy
        [property: string]: any;
    };
    orgIdsVsOrgNames: {
        [property: string]: string;
    };
    relatedTenants: {
        //serviceId vs relatedTenants
        [property: string]: any[];
    };
}
